const loadMorePosts = function(){
    var load_more_posts_btn = $('#news-load-more');
    var rootPath = load_more_posts_btn.attr('path');
    
    load_more_posts_btn.on('click', function(e){
        e.preventDefault();

        var list = $('#posts-list'),
        offset = list.find('.post-item').length;
        
        var months = ["stycznia","lutego","marca","kwietnia","maja","czerwca","lipca","sierpnia","września","października","listopada","grudnia"];
        
        $.ajax({
            url: rootPath+"ajax/get-more-posts",
            type: 'POST',
            data: {
                offset: offset
            },
            dataType: "json",
            success: function (data) { 

                if( data.length === 0 ){
                    load_more_posts_btn.fadeOut();
                }

                $.each( data, function( key ) {
                    
                    var id = data[key].id,
                        title = data[key].title,
                        date = new Date(data[key].createDate),
                        content = data[key].content.replace(/<\/?[^>]+(>|$)/g, ""),
                        cover = data[key].cover.replace("/uploads", "/uploads/medium/"),
                        route = data[key].route;
                    
                    console.log(date);
                        
                    var dateDay = date.getDate();
                    var dateMonth = date.getMonth();
                    var dateYear = date.getFullYear();

                    if (content.length > 150){
                        content = content.substring(0, 150)+ ' ...';
                    }
                    
                    var postItem = 
                        '<div class="col-sm-12 col-md-6 col-lg-4 post-item">'+
                            '<a href="/poradnik-inwestora/'+route+'" class="news-item">'+
                                '<div class="img-wrapper">'+
                                    '<img src="'+cover+'" alt="'+title+'">'+
                                '</div>'+
                                '<div class="info-wrapper">'+
                                    //'<span class="date">'+dateDay+' '+months[dateMonth]+' '+dateYear+'</span>'+
                                    '<h3 class="title">'+title+'</h3>'+
                                    '<p class="description">'+content+'</p>'+
                                '</div>'+
                            '</a>'+
                        '</div>';
                            
                    $(postItem).hide().appendTo(list).fadeIn();

                    //list.append();
                });

            },
            error: function (error) { console.log('error'); }
        })

    });
}
 
 module.exports = {
    loadMorePosts, 
 };